




































import Vue from "vue";
import Api from "../api/api";
import MenuButton from "../domain/menu-button";

interface Data {
  loading: boolean;
  hasBackofficeAccess: boolean;
  allButtons: MenuButton[];
}

const isDemo = true;

export default Vue.extend({
  data(): Data {
    return {
      loading: false,
      hasBackofficeAccess: false,
      allButtons: [
        {
          icon: "people",
          text: "Lista clienti",
          path: "/customers"
        },
        {
          icon: "pivot_table_chart",
          text: "Storico compliance",
          path: "/customers-consents"
        },
        {
          icon: "file_download",
          text: "Confronto dati anima",
          path: "/send-anima-compare"
        },
        {
          icon: "add",
          text: "Aggiungi cliente",
          path: "/new-customer-data",
          ifPredicate: () => !isDemo
        }
      ]
    };
  },

  computed: {
    buttons(): MenuButton[] {
      return this.allButtons.filter(button =>
        button.ifPredicate ? button.ifPredicate() : true
      );
    }
  },

  async mounted() {
    this.loading = true;

    const rolesResponse = await Api.user.isInRolesAsync([
      "super_admin",
      "admin",
      "anima_administrator",
      "uo_admin"
    ]);

    if (!rolesResponse.success) {
      this.$q.loading.hide();
      this.$q.notify({
        progress: true,
        message:
          "Si è verificato un errore nel comunicare con il server di backoffice, contattare l'assistenza.",
        type: "negative"
      });
    }

    this.hasBackofficeAccess = rolesResponse.result.isInRoles;

    this.loading = false;
  }
});
